import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { FertigationDashboardComponent } from './fertigation-dashboard.component';

export const fertigationDashboardRoutes: Routes = [
  {
    path: 'fertigation-dashboard',
    component: FertigationDashboardComponent,
    canActivate: [CustomerGuard],
  },
];
